<template lang="pug">
  .students
    .gallery
      .person(v-for="(student, index) in students")
        .image(@click="select(index)")
          label(:class="{ need: student.status === 'NEED INFORMATION', have: student.status === 'HAVE INFORMATION', dead: student.status === 'DECEASED' }") {{student.status}}
          img(:src="base + 'images/' + student.url")
        a.button(:href="'mailto:cb50threunionclassof1970@gmail.com?subject=Information about ' + student.name")
          span Email Information

    transition(name="fade")
      .modal(v-if="selected > -1", @click="close")
        .image(@keyup.right="next")
          img(:src="base + 'images/' + students[selected].url")
</template>

<script>

import axios from 'axios'

const base = (process.env.NODE_ENV === 'production') ? '/' : 'http://cb1970.com/'

export default {
  name: 'Students',
  components: {
  },
  data () {
    return {
      base,
      students: [],
      selected: -1
    }
  },
  mounted () {
    axios.get(`${base}api/students/get.php`)
      .then(result => {
        console.log(result)
        this.students = [...result.data, ...result.data, ...result.data, ...result.data, ...result.data, ...result.data, ...result.data, ...result.data]
      })
  },
  computed: {
  },
  methods: {
    select (index) {
      //console.log(index)
      this.selected = index
      document.body.addEventListener('keyup', this.navigate)
    },
    close () {
      this.selected = -1
      document.body.removeEventListener('keyup', this.navigate)
      //console.log('rmoved')
    },
    navigate (e) {
      //console.log(e.code)
      if (e.code === 'ArrowRight') {
        this.selected += 1
        if (this.selected >= this.students.length) {
          this.selected = 0
        }
      } else if (e.code === 'ArrowLeft') {
        this.selected -= 1
        if (this.selected < 0) {
          this.selected = this.students.length - 1
        }
      } else if (e.code === 'Escape') {
        this.close()
      }
    }
  }
}
</script>

<style lang="stylus">  
  .gallery
    display flex
    flex-wrap wrap
    .person
      padding 20px
      //width 25%
      //max-height 300px
      .image
        position relative
        label
          background-color rgba(0,0,0,.5)
          color #fff
          padding 5px
          position absolute
          &.need
            background-color rgba(200,0,0,.5)
          &.have
            background-color rgba(66, 135, 245,.5)
      img
        max-height 500px
        vertical-align top
  .modal
    align-items center
    justify-content center
    background-color rgba(0,0,0,.5)
    display flex
    position fixed
    top 0
    right 0
    left 0
    bottom 0
    img
      border 2px solid #fff
      height 90vh
      vertical-align top
      

.fade-enter-active, .fade-leave-active
  transition opacity .3s
.fade-enter, .fade-leave-to
  opacity 0
  
</style>
